import monoApi from "@/core/services/monoapi.service"

// action types
export const GET_EXTRAS = "getExtras";

// mutation types
export const REQUEST_EXTRAS = 'REQUEST_EXTRAS'
export const REQUEST_EXTRAS_SUCCESS = 'REQUEST_EXTRAS_SUCCESS'
export const REQUEST_EXTRAS_ERROR = 'REQUEST_EXTRAS_ERROR'

export default {
    state: {
        isFetching: false,
        error: null,
        item: {},
        items:[],
        validation: {}
    },
    getters: {
        /**
         * Get list of breadcrumbs for current page
         * @param state
         * @returns {*}
         */
        
    },
    actions: {
        /**
         * Set the breadcrumbs list
         * @param state
         * @param payload
         */
        [GET_EXTRAS] ({ commit } ) {      
            commit(REQUEST_EXTRAS)
            return monoApi.get(`/extras/`)
                .then(res => {
                    commit(REQUEST_EXTRAS_SUCCESS, {
                        payload: res.data
                    })
                })
                .catch(error => {
                    commit(REQUEST_EXTRAS_ERROR, { error })
                })
        },  
    },
    mutations: {
        [REQUEST_EXTRAS] (state) {
            state.isFetching = true
            state.error = null
        },
    
        [REQUEST_EXTRAS_SUCCESS] (state, action) {
        state.isFetching = false
        state.items = [...action.payload]    
        state.error = null
        },
    
        [REQUEST_EXTRAS_ERROR] (state, action) {
        state.isFetching = false
        state.error = action.error
        }
    }        
}
